<template>
  <div class="h-100 pt-5 pb-1">
    <div class="text-center text-value-lg mb-5">
      <span class="mx-2 fw-bold me-2"> From:</span
      >{{ activeKiosk.user.first_name + " " + activeKiosk.user.last_name }} ({{
        activeKiosk.room
          ? activeKiosk.room.name
          : activeKiosk.user
          ? activeKiosk.user.name
          : ""
      }})
    </div>
    <div class="d-flex mt-4 justify-content-between">
      <button
        class="btn bg-gradient-blue text-white d-block w-100 py-4 mx-2"
        @click="setActiveTab('createPass')"
      >
        NEW PASS
      </button>
      <button
        class="btn bg-gray text-white d-block w-100 py-4 mx-2"
        @click="setActiveTab('endPass')"
      >
        END PASS
      </button>
    </div>
    <div class="d-flex align-items-center justify-content-center mt-5">
      <a
        class="text-accent-blue-dark"
        target="_blank"
        href="https://eduspiresolutions.org/terms-of-use/"
        >Terms of Use</a
      >
      <span class="mx-2">|</span>
      <a
        class="text-accent-blue-dark"
        target="_blank"
        href="https://eduspiresolutions.org/privacy-policy/"
        >Privacy policy</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "KioskMainScreen",
  props: ["activeKiosk"],
  emits: ["tabChanged"],
  methods: {
    setActiveTab(tab) {
      this.$emit("tabChanged", tab)
    }
  }
}
</script>
